import { StepPersonalData } from './StepPersonalData'
import { StepPlansCoverage } from './StepPlansCoverage'
import { StepPersonalDataPart2 } from './StepPersonalDataPart2'
import { StepBeneficiaries } from './StepBeneficiaries';
import { StepPurchaseSummary } from './StepPurchaseSummary';
import { StepFinish } from './StepFinish'
import { StepPaymentCompleted } from './StepPaymentCompleted'
import { StepAutomaticPayment } from './StepAutomaticPayment'
import {StepFinishAge} from './StepFinishAge'

const Step = ({ index = 0 , loading = false}: IPropsPages) => {
    const switchPage = [
        <StepPersonalData />,
        <StepPlansCoverage  loadData={loading} />,
        <StepPersonalDataPart2 />,
        <StepBeneficiaries />,
        <StepPurchaseSummary />,
        <StepAutomaticPayment />,
        <StepPaymentCompleted />,
        <StepFinish />,
        <StepFinishAge/>
    ]
    return (
        <>
            {switchPage[index]}
        </>
    );
}

export { Step };